import { c as _c } from "react/compiler-runtime";
import { Skeleton } from '@achra/ui/skeleton';
import { ChevronRight } from 'lucide-react';
interface BreadcrumbSkeletonProps {
  segments: number;
}
function Separator() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <ChevronRight className="text-foreground/30 size-6 pr-1" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
function Segment(t0) {
  const $ = _c(2);
  const {
    width: t1
  } = t0;
  const width = t1 === undefined ? "w-20" : t1;
  const t2 = `h-6 ${width}`;
  let t3;
  if ($[0] !== t2) {
    t3 = <Skeleton className={t2} />;
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  return t3;
}
function MobileSkeleton(t0) {
  const $ = _c(2);
  const {
    segments
  } = t0;
  if (segments > 1) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <><Segment width="w-8" /><Separator /><Segment /></>;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Segment />;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}
function DesktopSkeleton(t0) {
  const $ = _c(4);
  const {
    segments
  } = t0;
  if (segments === 1) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <Segment />;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  if (segments === 2) {
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <><Segment /><Separator /><Segment /></>;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    return t1;
  }
  if (segments === 3) {
    let t1;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <><Segment /><Separator /><Segment /><Separator /><Segment /></>;
      $[2] = t1;
    } else {
      t1 = $[2];
    }
    return t1;
  }
  let t1;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <><Segment /><Separator /><Segment width="w-8" /><Separator /><Segment /><Separator /><Segment /></>;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}
function BreadcrumbSkeleton(t0) {
  const $ = _c(7);
  const {
    segments
  } = t0;
  let t1;
  if ($[0] !== segments) {
    t1 = <div className="flex items-center gap-2.5 lg:hidden"><MobileSkeleton segments={segments} /></div>;
    $[0] = segments;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== segments) {
    t2 = <div className="hidden items-center gap-2.5 lg:flex"><DesktopSkeleton segments={segments} /></div>;
    $[2] = segments;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <div>{t1}{t2}</div>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}
export { BreadcrumbSkeleton };